export const NEW_PROJECT = {
  label: "New Project",
  value: "newProject"
};
